export const TimeOffPolicyEnum: { [key: string]: string } = {
  vacation: "Vacation",
  sickLeave: "Sick Leave",
  additionalHolidays: "Additional Holidays",
  unpaidLeave: "Unpaid Leave",
  parentalLeave: "Parental Leave",
  floatingHolidays: "Floating Holidays",
  workFromHome: "Work From Home",
  shortDay: "Short Day",
  publicHoliday: "Public Holiday",
  paidTimeOff: "Paid Time Off",
};

export const TimeOffPolicyDescriptions: { [key: string]: string } = {
  vacation:
    "Annual paid leave lasting 28 calendar days, excluding official public holidays.",
  sickLeave:
    "Medical leave recorded upon issuance of a medical certificate by a healthcare institution.",
  additionalHolidays:
    "Paid additional leave for family-related reasons, expressed in working days:\n" +
    "- Employee's marriage – 3 days\n" +
    "- Marriage of employee's child – 1 day\n" +
    "- Adoption of a child – 1 day\n" +
    "- Death of parents, parents-in-law, spouse, or child – 3 days\n" +
    "- Death of sibling or grandparent – 1 day\n" +
    "- Parents with children in grades 1 and 2 – 1 day at the beginning of the school year and 1 day at the end of the school year\n" +
    "Supporting documents are required for additional holiday.",
  unpaidLeave: "Unpaid leave (non-remunerated).",
  parentalLeave:
    "Paternity leave granted to fathers upon the birth of a child, lasting 15 calendar days, fully paid by the state.",
  floatingHolidays:
    "Floating holidays can be requested based on the employee's available floating holiday balance.",
  workFromHome: "Remote work arrangement.",
  shortDay:
    "Once per month, a reduced working day of 4 hours, requested at least 3 days in advance.",
  publicHoliday:
    "Work on a designated public holiday and take another day off in exchange.",

  paidTimeOff:
    "Paid Time Off (PTO) is calculated according to your work anniversary year. The amount of PTO received each year is based on your length of service and accrues according to an accrual schedule determined by the Company up to a maximum annual grant as shown below:\n" +
    "- First year of employment: 56 hours annually (7 days)\n" +
    "- Second through fourth year of employment: 80 hours annually (10 days)\n" +
    "- Fifth through ninth year of employment: 120 hours annually (15 days)\n" +
    "- Over ten years of employment: 160 hours annually (20 days)\n" +
    "Part-time regular employees receive PTO time in proportion of their work schedule.\n" +
    "PTO granted during your first year of employment will be prorated based on your hire date.",
};
